import { FhSideBarHeaderConfigInterface } from '../../interfaces/fh-side-bar-header-config/fh-side-bar-header-config-interface';

export class FhSideBarHeaderConfigModel implements FhSideBarHeaderConfigInterface {
  navigateBackButton: boolean = false;
  outlet?: string;
  parentNavigation: string | null = null;
  parentLabel: string = '';
  return?: boolean = false;
  segmentsToRemove?: number | undefined;
  constructor(init?: Partial<FhSideBarHeaderConfigModel>) {
    Object.assign(this, init);
  }
}
